import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Blogs from "./pages/Blogs";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import ProcessPage from "./pages/ProcessPage";
import SuccessStories from "./pages/SuccessStories";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* About */}
        <Route path="/about" element={<About />} />

        {/* Programs */}
        <Route path="/programs" element={<Programs />} />

        {/* Success Stories */}
        <Route
          path="/success-stories"
          element={<SuccessStories />}
        />

        {/* Process */}
        <Route
          path="/process"
          element={<ProcessPage />}
        />

        {/* Blogs */}
        <Route
          path="/blogs"
          element={<Blogs />}
        />

        {/* FAQ */}
        <Route
          path="/faq"
          element={<FAQPage />}
        />

        {/* Contact */}
        <Route
          path="/contact"
          element={<ContactPage />}
        />

        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

      </Routes>
    </BrowserRouter>
  );
}